import {FC, useEffect} from 'react';
//mui
import {Box, Typography} from '@mui/material';
//formik
import {Field, useFormikContext} from 'formik';
import {AddTableTicketFormValues} from '../../formConfiguration';
//components
import Input from '@/shared/components/Inputs/Input';
import MultipleSelect from '@/shared/components/MultipleSelect';
//constants
import {
  FIELD,
  FIELD_LABEL,
  NONE,
  NUMBER,
  PLACEHOLDER,
  PURCHASER,
  SUBTITLE1,
  TABLE_PURCHASER,
  mealsSelectOptions,
} from '@/utils/constants';
//helpers
import {setRequiredLabel} from '@/utils/helpers';
//styles
import {tablePurchaserStyle} from './TablePurchaser.styles';
import {useApiInstance} from '@/contexts/ApiInstanceContext';
import {USER_TYPE} from '@/utils/enums';
import {useSelector} from 'react-redux';
import {getUserSelector} from '@/store/user';

const TablePurchaser: FC = () => {
  const {
    values: {purchaser},
    setFieldValue,
  } = useFormikContext<AddTableTicketFormValues>();

  const {role} = useApiInstance();
  const user = useSelector(getUserSelector);

  useEffect(() => {
    if (role === USER_TYPE.USER) {
      if (user?.firstName) {
        setFieldValue(`${PURCHASER}.${FIELD.firstName}`, user.firstName);
      }
      if (user?.lastName) {
        setFieldValue(`${PURCHASER}.${FIELD.lastName}`, user.lastName);
      }
      if (user?.email) {
        setFieldValue(`${PURCHASER}.${FIELD.email}`, user.email);
      }
      if (user?.phoneNumber) {
        setFieldValue(`${PURCHASER}.${FIELD.phoneNumber}`, user.phoneNumber);
      }
      if (user?.meals) {
        setFieldValue(`${PURCHASER}.${FIELD.meals}`, user.meals);
      }
    }
  }, [role]);

  return (
    <Box sx={tablePurchaserStyle.wrapper}>
      <Typography variant={SUBTITLE1} sx={tablePurchaserStyle.title}>
        {TABLE_PURCHASER}:
      </Typography>

      <Box sx={tablePurchaserStyle.content}>
        <Box sx={tablePurchaserStyle.names}>
          <Field
            id={`${PURCHASER}.${FIELD.firstName}`}
            name={`${PURCHASER}.${FIELD.firstName}`}
            placeholder={PLACEHOLDER.firstName}
            label={setRequiredLabel(FIELD_LABEL.firstName)}
            component={Input}
            isObjectData
          />
          <Field
            id={`${PURCHASER}.${FIELD.lastName}`}
            name={`${PURCHASER}.${FIELD.lastName}`}
            placeholder={PLACEHOLDER.lastName}
            label={setRequiredLabel(FIELD_LABEL.lastName)}
            component={Input}
            isObjectData
          />
        </Box>
        <Box sx={tablePurchaserStyle.data}>
          <Field
            id={`${PURCHASER}.${FIELD.email}`}
            name={`${PURCHASER}.${FIELD.email}`}
            placeholder={PLACEHOLDER.emailEnter}
            label={setRequiredLabel(FIELD_LABEL.email)}
            component={Input}
            isObjectData
          />
          <Field
            id={`${PURCHASER}.${FIELD.phoneNumber}`}
            name={`${PURCHASER}.${FIELD.phoneNumber}`}
            placeholder={PLACEHOLDER.phoneNumberZero}
            label={FIELD_LABEL.phoneNumber}
            // label={setRequiredLabel(FIELD_LABEL.phoneNumber)}
            component={Input}
            type={NUMBER}
            isObjectData
          />
          <Box sx={tablePurchaserStyle.meals}>
            <Field
              id={`${PURCHASER}.${FIELD.meals}`}
              name={`${PURCHASER}.${FIELD.meals}`}
              value={purchaser.meals}
              defaultValue={NONE}
              label={FIELD_LABEL.meals}
              component={MultipleSelect}
              options={mealsSelectOptions}
              isObjectData
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TablePurchaser;
